import type { IProofStripCell } from "~/feature/getUpdates/types";
import type { IMetrics } from "~/types/metrics";
import { formatNumber, formatValueFloor } from "~/utils/formatValue";

export const buildProofStrip = (
  metrics: IMetrics | null | undefined
): IProofStripCell[] | null => {
  if (!metrics) return null;

  const { matchedEventGroups, totalMarkets, volume24h } = metrics;

  if (!(matchedEventGroups > 0) || !(totalMarkets > 0) || !(volume24h > 0)) {
    return null;
  }

  return [
    {
      value: formatNumber(matchedEventGroups, { withDollar: false }),
      label: "CROSS-PLATFORM EVENTS",
    },
    {
      value: formatNumber(totalMarkets, { withDollar: false }),
      label: "LIVE MARKETS TRACKED",
    },
    {
      value: formatValueFloor(volume24h),
      label: "24H VOLUME TRACKED",
    },
  ];
};
